import { render, staticRenderFns } from "./TicketTypeList.vue?vue&type=template&id=06bbc564&scoped=true"
import script from "./TicketTypeList.vue?vue&type=script&lang=js"
export * from "./TicketTypeList.vue?vue&type=script&lang=js"
import style0 from "./TicketTypeList.vue?vue&type=style&index=0&id=06bbc564&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bbc564",
  null
  
)

export default component.exports